import { getField, updateField } from 'vuex-map-fields';

const defaultState = {
  global: {
    vat_schemes: [],
  },
  invoice: {},
  subscription: {},
};

const mutations = {
  updateField,
  configDataSave: (state, action) => {
    Object.assign(state, action.payload.data.configs);
  },
  setConfigFromWindow: (state, data) => {
    Object.assign(state, data.configs);
  },
  configDataError: () => {
    // console.log('error get config');
  },
  setColumnsConfig: (state, { scope, columns }) => {
    state.subscription.column_settings = {
      ...state.subscription.column_settings,
      [scope]: columns,
    };
  },
  changeEetStatus: (state, status) => {
    state.subscription['eet_enabled?'] = status;
  },
  changeEetVisibility: (state, status) => {
    state.subscription['eet_visible?'] = status;
  },
  setInvoicesStateConfig: (state, payload) => {
    state.subscription['states_enabled?'] = payload;
  },
  setInvoicesWithoutState: (state, payload) => {
    state.subscription['invoices_without_state?'] = payload;
  },
  setLineSuggestionConfig: (state, payload) => {
    state.subscription['suggestions_enabled?'] = payload;
  },
};

const actions = {
  getConfigData({ commit, dispatch }) {
    if (window && window.vueInvoiceConfig) {
      commit('setConfigFromWindow', window.vueInvoiceConfig);
    } else {
      dispatch('fetchConfigData');
    }
  },
  fetchConfigData({ commit, rootGetters }) {
    commit(
      'api/fetch',
      {
        url: '/configs.json',
        method: 'GET',
        headers: {
          ...rootGetters['auth/getHeaders'],
        },
        onSuccess: ['config/configDataSave'],
        onError: ['config/configDataError'],
      },
      { root: true },
    );
  },
  setColumnsConfig({ commit }, { scope, columns }) {
    commit('setColumnsConfig', {
      scope,
      columns,
    });
  },
  configDataSave({ commit }, payload) {
    commit('configDataSave', payload);
  },
  configDataError({ commit }, payload) {
    commit('configDataError', payload);
  },
  changeEetStatus({ commit }, payload) {
    commit('changeEetStatus', payload);
  },
  changeEetVisibility({ commit }, payload) {
    commit('changeEetVisibility', payload);
  },
  setInvoicesStateConfig({ commit }, payload) {
    commit('setInvoicesStateConfig', payload);
  },
  setLineSuggestionConfig({ commit }, payload) {
    commit('setLineSuggestionConfig', payload);
  },
  setInvoicesWithoutState({ commit }, payload) {
    commit('setInvoicesWithoutState', payload);
  },
};

const getters = {
  getField,
};

// A Vuex instance is created by combining the state, mutations, actions,
// and getters.
export default {
  namespaced: true,
  state: defaultState,
  getters,
  actions,
  mutations,
};
